import { atom } from 'recoil';

const dataManagementEntityAtom = atom({
    key: 'projectManagement_dataManagementEntity',
    default: null,
});

export default dataManagementEntityAtom;
